// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"c273f9c4","745":"c1a5962c","787":"aa27c36b"}[chunkId] + ".chunk.js";
};